<template>
<div>
  <loader v-if="load"></loader>
  <d-container class="h-100">
    <d-row class="h-100 mt-3">
      <d-col class="main-content p-0" tag="main" sm="12">
        <d-row class="justify-content-center">
          <d-col cols="12" md="8" lg="7" xl="6">
            <div class="title">
              <img
                id="main-logo"
                src="@/assets/images/logo.png"
                alt="Manager Sync360"
                >
            </div>
          </d-col>
        </d-row>
        <d-row class="justify-content-center">

          <d-col cols="12">
            <d-card class="card-small mb-4 p-4">
              <h4 class="text-center">Formulário de avaliação</h4>
              <!-- Content -->
              <answer-form :form="model" :title="title"/>

            </d-card>
          </d-col>
        </d-row>

        <!-- Footer -->
        <footer class="main-footer d-flex p-2 px-3">
          <div class="container">
            <div class="align-items-center row h-100 text-center">
              <span class="copyright col-12 ml-auto my-auto mr-2">Copyright © 2019 <d-link href="http://sync360.io" target="_blank">Sync360.io</d-link></span>
            </div>
          </div>
        </footer>
      </d-col>

    </d-row>
  </d-container>
</div>
</template>


<script>
import { mapActions } from 'vuex';
import Loader from '_shared/Loader.vue';
import RatingService from '_services/rest/modules/rating';
import AnswerForm from '../components/AnswerForm.vue';

export default {
  name: 'rating-answer',
  components: {
    Loader,
    AnswerForm,
  },
  data() {
    return {
      model: {
        id: null,
        rating: {
          name: 'Verificando token',
          questions: [],
        },
        token: this.$route.params.token,
      },
      loading: false,
      invalidToken: true,
      error: null,
    };
  },
  computed: {
    title() {
      return this.model.rating.name;
    },
    load() {
      const Loading = this.$store.state.toggle.progress;
      if (Loading) {
        return Loading;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    checkToken() {
      RatingService.checkToken(this.model.token)
        .then(response => {
          this.model = response;
        })
        .catch(error => {
          this.model.rating.name = 'Token inválido ou você já respondeu a avaliação';
          this.activeAlert({ message: `${error.message}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    this.checkToken();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.title {
  color: #fff;
  font-size: 18px;
  margin: 0 0 15px 0;
  justify-content: center;
  height: 110px;
  align-items: center;
  display: flex;
  img {
    max-height: 80px;
    max-width: 80%
  }
}
</style>
